import { Logger } from '../common';
import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { LogMessage } from '../models';

let INSTALLED = false;

@Injectable()
export class ServerLogger {
    constructor(
        @Inject(PLATFORM_ID)
        private platformId : any
    ) {
        let glob = {};

        if (typeof window !== 'undefined')
            glob = window;
        else
            glob = global;

        glob['serverLogger'] = this;
        
        this.isServer = isPlatformServer(platformId);
    }

    private isServer = false;
    private logBatch : LogMessage[] = [];

    public async crash(title : string, prefixMessage : string = null) {

        let batch = this.logBatch;
        this.logBatch = [];

        if (prefixMessage)
            batch = [new LogMessage({ m: prefixMessage })].concat(batch);
        
        try {
            await LogMessage.sendCrash(title, batch);
        } catch (e) {
            console.error('Failed to send crash logs: '+e.message);
            console.error(e);
        }
    }

    public async flush(prefixMessage : string = null) {
        
        let batch = this.logBatch;
        this.logBatch = [];

        if (prefixMessage)
            batch = [new LogMessage({ m: prefixMessage })].concat(batch);
        
        try {
            await LogMessage.sendBatch(batch);
        } catch (e) {
            console.error('Failed to send log batch: '+e.message);
            console.error(e);
        }
    }

    public enableAndSend() {
        this.enabled = true;
        this.sendBatch();
    }
    
    public enabled : boolean = false;

    public bufferLimit : number = 1000;

    get logBuffer() {
        return this.logBatch.splice(0);
    }

    install() {

        if (INSTALLED)
            return;
        INSTALLED = true;

        if (!this.isServer) {
            setInterval(() => {
                this.sendBatch();
            }, 5000);
        }

        let glob = {};
        
        if (typeof window !== 'undefined')
            glob = window;
        else
            glob = global;

        Logger.beforeLog((...args) => glob['serverLogger'].logNoColor(args));
        Logger.beforeError((...args) => glob['serverLogger'].logNoColor(args));
        Logger.beforeDir((...args) => glob['serverLogger'].logNoColor(args));
    }

    private logNoColor(args : any[]) {

        args = args.map(x => {
            if (x && x.stack)
                return x.stack 
            return x;
        });

        let argStr = args.join(', ');
        if (args[0] && typeof args[0] === 'string' && args[0].startsWith('%c')) {
            argStr = [args[0].substr(2)].concat(args.slice(2)).join(', ');
        }

        this.log(argStr);
    }

    private log(m : string) {
        //if (this.isServer)
        //    return;
        
        // Filter out color codes 
        if (this.isServer) {
            m = m.replace(/\u001b\[[^m]+m/g, '');
        }

        let message = new LogMessage({ m });

        this.logBatch.push(message);

        // Maintain the size of the logs buffer so it does not take up too much
        // memory.

        if (this.logBatch.length > this.bufferLimit)
            this.logBatch = this.logBatch.slice(-this.bufferLimit);
    }

    private sendBatch() {
        if (!this.enabled)
            return;
        
        if (this.logBatch.length == 0)
            return;
        
        this.flush();
    }
}